import { Box, Checkbox, FormControlLabel, InputLabel, Stack, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { LoadConfirmFormContainer } from 'components/forms/forms.styles'
import FormSingleColumnLayout from 'layouts/form-single-column-layout/form-single-column-layout'
import TextInputField from 'components/fields/text-input-field/text-input-field.component'
import { LoadConfirmationFormValues } from '../schema'

export function MyCompanyTab() {
  const { control } = useFormContext<LoadConfirmationFormValues>()

  return (
    <LoadConfirmFormContainer container spacing={2} $compact>
      <FormSingleColumnLayout>
        <Stack spacing={1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <InputLabel sx={{ color: 'error.main', fontWeight: 700, m: 0 }}>
              My Company Name
            </InputLabel>
            <Controller
              name="saveMyCompanyForFuture"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  sx={{ m: 0, flexShrink: 0 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={Boolean(field.value)}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  }
                  label="Save for Future Loads"
                />
              )}
            />
          </Box>
          <Controller
            name="myCompanyName"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                placeholder="Answer"
                size="small"
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Stack>

        <TextInputField label="Address" name="myCompanyAddress" />
        <TextInputField label="Issued By" name="issuedBy" />
        <TextInputField label="Dispatch Email" name="myCompanyEmail" />
        <TextInputField label="Phone" name="myCompanyPhone" />
        <TextInputField label="Cell" name="myCompanyCell" />
        <TextInputField label="After Hours Phone" name="myCompanyAfterHoursPhone" />
        <TextInputField label="Invoice & POD Name" name="invoicePodContactName" />
        <TextInputField label="Invoice & POD Email" name="invoicePodEmail" />
        <TextInputField label="Invoice & POD Phone" name="invoicePodPhone" />
      </FormSingleColumnLayout>
    </LoadConfirmFormContainer>
  )
}

type NotesTabProps = {
  fillHeight?: boolean
}

export function NotesTab({ fillHeight = false }: NotesTabProps) {
  const { control } = useFormContext<LoadConfirmationFormValues>()

  return (
    <LoadConfirmFormContainer
      container
      spacing={2}
      $compact
      sx={
        fillHeight
          ? {
              height: '100%',
              minHeight: '100%',
              display: 'flex',
              flexDirection: 'column',
              '& > .MuiGrid2-root': { flex: 1, display: 'flex', flexDirection: 'column' },
            }
          : undefined
      }
    >
      <FormSingleColumnLayout>
        <Stack
          spacing={1}
          sx={fillHeight ? { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } : undefined}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
              flexShrink: 0,
            }}
          >
            <InputLabel sx={{ fontWeight: 700, m: 0 }}>Note</InputLabel>
            <Controller
              name="saveNotesForFuture"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  sx={{ m: 0, flexShrink: 0 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={Boolean(field.value)}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  }
                  label="Save for Future Loads"
                />
              )}
            />
          </Box>
          <Controller
            name="notes"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                placeholder="Answer"
                size="small"
                multiline
                minRows={fillHeight ? 12 : 6}
                maxRows={fillHeight ? 12 : 6}
                error={!!error}
                helperText={error?.message}
                sx={
                  fillHeight
                    ? {
                        flex: 1,
                        minHeight: 0,
                        '& .MuiInputBase-root': {
                          alignItems: 'flex-start',
                        },
                        '& textarea': {
                          resize: 'none',
                        },
                      }
                    : undefined
                }
              />
            )}
          />
        </Stack>
      </FormSingleColumnLayout>
    </LoadConfirmFormContainer>
  )
}
